// Gedeeld uitklapgedrag (info_boxes, steps_accordion): één item tegelijk open.
// Zonder JS staan alle items open; de dichte stand zit alleen onder het ready-attribuut op de wrapper.
export function initAccordion({ root, item, toggle, panel, openClass, readyAttr }) {
	const items = [...root.querySelectorAll(item)];

	const setOpen = (el, open) => {
		el.classList.toggle(openClass, open);
		el.querySelector(toggle).setAttribute("aria-expanded", String(open));
		el.querySelector(panel).inert = !open;
	};

	items.forEach((el) => {
		setOpen(el, el.classList.contains(openClass));

		el.querySelector(toggle).addEventListener("click", () => {
			const wasOpen = el.classList.contains(openClass);

			items.forEach((other) => setOpen(other, false));
			if (!wasOpen) setOpen(el, true);
		});
	});

	root.setAttribute(readyAttr, "");
}
